import { render, staticRenderFns } from "./temporaryDelivery.vue?vue&type=template&id=2f371290&scoped=true"
import script from "./temporaryDelivery.vue?vue&type=script&lang=js"
export * from "./temporaryDelivery.vue?vue&type=script&lang=js"
import style0 from "./temporaryDelivery.vue?vue&type=style&index=0&id=2f371290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f371290",
  null
  
)

export default component.exports